<template>
  <div id="app">
    <!-- <b-container><b-row><b-col cols="12" class="text-center mt-3">{{time}}</b-col></b-row></b-container> -->
    <!-- <div id="nav">{{app_lang}}
      <router-link :to="'/' +app_lang+ '/'">Home</router-link> |
      <router-link :to="'/' +app_lang+ '/about'">About</router-link> | 
      <router-link :to="{name: $route.name, params: { lang: 'pt' }}">PT</router-link> |
      <router-link :to="{name: $route.name, params: { lang: 'en' }}">EN</router-link>
    </div> -->
    <!-- <router-view v-bind:time="time" :key="$route.fullPath"></router-view> -->
    <Container :key="$route.fullPath"></Container>
  </div>
</template>
<script>

import Container from '@/components/Container';

export default {
  data() {
    return {
      app_lang: localStorage.getItem('lang'),
    }
  },
  components: {
    Container,
  },
  methods: {

  },
  computed: {

  },
  watch: {
    '$route.params.lang': function(new_val, old_val) {
      this.app_lang = new_val;
    }
  },
  created: function() {
    
  }
}


</script>
<style>

@import '../node_modules/bootstrap/dist/css/bootstrap.css';
@import '../node_modules/bootstrap-vue/dist/bootstrap-vue.css';
@import './assets/css/fontawesome.min.css';

@import url('https://fonts.googleapis.com/css?family=Titillium+Web:400,200,300,300italic,200italic,600,400italic,600italic,700,700italic,900%7CRaleway')

*, *:before, *:after {
    -webkit-box-sizing: border-box;
       -moz-box-sizing: border-box;
            box-sizing: border-box;
}

html {
  height: 100%;
}
body {
  font-family: 'Titillium Web', sans-serif;
}
img {

}
.color-stamp {
  width: 10px;
  height: 10px;
}
.no-border {
  border: none;
}
.my-action-btn:hover {
  background-color: #476061;
}
.my-action-btn:disabled, .my-action-btn.disabled {
  background-color: #394d4b;
}
.color-green {
  color: #19998a;
}
.cursor-pointer {
  cursor: pointer;
}
.cursor-no-pointer {
  cursor: auto;
  pointer-events: none;
}
.border-green {
  border: 2px solid #19998a;
}
.border-green-light {
  border: 2px solid #58ccc2;
}
.bg-green-dark {
  background-color: #19998a;
}
.bg-green-light {
  background-color: #58ccc2;
}
.bg-grey-light {
  background-color: #ebf5f4;
}
.bg-grey-dark {
  background-color: #476061;
}
.bg-white {
  background-color: #ffffff;
}
.font-size-0 {
  font-size: 0;
}
.font-bold {
  font-weight: bold;
}
.nav {
  top: 0;
  left: 0;
}
.z-index-1 {
  z-index: 1;
}

.my-btn:focus.bg-green {
  background-color: #19998a;
  box-shadow: none;
}



.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .8);
  display: table;
  transition: opacity .3s ease;
}
.modal-container {
  max-width: 600px;
  margin: auto auto;
  max-height: 100%;
  overflow-y: auto;
  padding: 15px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
  padding: 15px;
}
.close-container {
  text-align: right;
}
.close-container .close-btn {
  cursor: pointer;
  border: none;
  font-size: 20px;
  background-color: transparent;
  outline: none;
}
.modal-body {
  margin: 20px 0;
  padding: 0;
}
.modal-header {
  padding: 0;
}
.modal-default-button {
  float: right;
}
.modal-enter {
  opacity: 0;
}
.modal-leave-active {
  opacity: 0;
}
.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

</style>
